import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import themeLarge from "../ThemeLarge";

const tabs = [
  { label: "Dashboard",  path: "/dashboard" },
  { label: "Projects",   path: "/dashboard/projects" },
  { label: "Timeline",   path: "/dashboard/timeline" },
  { label: "Vitals",     path: "/dashboard/vitals" },
];

const DashboardSidebar = ({ isOpen, onToggle }) => {
  const location = useLocation();

  return (
    <div
      onClick={onToggle}
      style={{
        width: isOpen ? "180px" : "40px",
        transition: "width 0.5s ease-in",
        background: "#f8f9fa",
        paddingTop: "50px",
        // height: "calc(100vh - 56px)", // adjust to your navbar height
        borderRight: "1px solid #ddd",
        fontFamily: "Kumbh Sans",
        overflow: "hidden",
        position: "relative", // key for placing absolute children inside
      }}
    >
      <div
        onClick={onToggle}
        style={{
          cursor: "pointer",
          position: "absolute", // position it relative to sidebar
          bottom: "40px", // space from bottom
          right: isOpen ? "10px" : "6px", // adjust padding based on state
          fontSize: "16px",
          color: "#555",
        }}
      >
        {isOpen ? <FaChevronLeft /> : <FaChevronRight />}
      </div>
      {isOpen &&
        tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          return (
            <Link
              key={tab.path}
              to={tab.path}
              style={{
                display: "block",
                padding: "12px 16px",
                textDecoration: "none",
                color: isActive ? "#fff" : "#333",
                backgroundColor: isActive
                  ? themeLarge.colors.primary
                  : "transparent",
                borderRadius: "4px",
                margin: "6px 12px",
                fontWeight: isActive ? "bold" : "normal",
              }}
            >
              {tab.label}
            </Link>
          );
        })}
    </div>
  );
};

export default DashboardSidebar;
